import React from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import FilterButton from '../FilterButton';
import { StyledFilterButton } from '../FilterButton/FilterButton';
import { TEST_ID_FILTER_BUTTON_LIST } from './constants';
import type { FilterButtonListProps } from './FilterButtonList';

import styles from './filterButtonList.module.css';

export const SwiperFilterButtonList = ({
  filters,
  onClickButton,
}: FilterButtonListProps) => (
  <StyledFilterButtonList
    data-testid={TEST_ID_FILTER_BUTTON_LIST}
    className={styles.swiperFilterButtonList}
  >
    <Swiper slidesPerView="auto" spaceBetween={8}>
      {filters.map((filter) => {
        const { name, title, isSelected, count } = filter;
        return (
          <SwiperSlide key={`slide-${filter.name}`}>
            <FilterButton
              key={name}
              title={title}
              count={count}
              name={name}
              onClick={onClickButton}
              isSelected={isSelected}
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  </StyledFilterButtonList>
);

const StyledFilterButtonList = styled.div`
  position: sticky;
  top: 74px;
  background: #f3f3f3;
  z-index: 2;
  padding: 8px 0;
  ${StyledFilterButton} {
    margin: 0 4px 4px 0;
  }
`;
